import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { createAccountTypesScreens } from "./account_types";
import { createAccountBalancesScreens } from "./account_balances";

type ScreenFactory = (firstName: string) => FlowScreenConfig[];

export const financialAccountsTasks: Record<string, ScreenFactory> = {
  account_types: createAccountTypesScreens,
  account_balances: createAccountBalancesScreens,
};
